// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"361":"5d8da395","583":"654fed46","676":"9c052e7f","690":"3403185b"}[chunkId] + ".chunk.css";
};